import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import { A } from "@motleyhand/design"

const Link = createLink(({ key, className, ...props }: ComponentProps<"a">) => (
  <A key={key} className={className} {...props} />
))

export default Link
